"use client";

import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "../../public/images/WebsiteImages/logo.png";
import Image from "next/image";
import MegaMenu from "./megaMenu";
import { Menu, X, ChevronDown } from "lucide-react";

const Header = ({ currentPage = "" }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSolutions, setShowSolutions] = useState(false);
  const [showPartnerMenu, setShowPartnerMenu] = useState(false);
  const [showChannels, setShowChannels] = useState(false);
  const channelsRef = useRef<HTMLDivElement>(null);
  const channelsTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const partnerRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleSolutions = () => setShowSolutions((prev) => !prev);
  const handleChannelsMouseEnter = () => {
    if (channelsTimeoutRef.current) {
      clearTimeout(channelsTimeoutRef.current);
    }
    setShowChannels(true);
  };

  const handleChannelsMouseLeave = () => {
    channelsTimeoutRef.current = setTimeout(() => {
      setShowChannels(false);
    }, 150);
  };

  const togglePartnerMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowPartnerMenu((prev) => !prev);
  };

  const handleLoginClick = () => {
    // Redirect to the login page
    // window.location.href = '/auth/login';
    // if(process.)
    // if (process.env.NEXT_PUBLIC_IS_LOCAL == "true") {
    //   window.location.href = '/auth/login';
    //   return
    // }
    window.location.href = "/auth/login";
  };

  const handleNavigateHome = () => {
    // Redirect to the home page
    window.location.href = "/";
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        partnerRef.current &&
        !partnerRef.current.contains(event.target as Node)
      ) {
        setShowPartnerMenu(false);
      }
      if (
        channelsRef.current &&
        !channelsRef.current.contains(event.target as Node)
      ) {
        setShowChannels(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#ebf2f0] ">
      <div className="flex justify-between items-center py-2 px-6">
        <div className="h-8 relative">
          <button onClick={handleNavigateHome}>
            <Image
              src={logo}
              alt="Farminsta Logo"
              width={120}
              height={20}
              className="object-contain"
            />
          </button>
        </div>
        <div className="flex-1 flex justify-center">
          <nav className="hidden md:flex items-center justify-center space-x-6 text-sm font-semibold relative flex-1">
            <a
              href="/"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "Home" && !showSolutions ? "text-green-600" : ""
              }`}
            >
              Home
            </a>

            <a
              href="/field-force-monitor"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "fieldForceMonitor" ? "text-green-600" : ""
              }`}
            >
              Field Force Monitor
            </a>

            <a
              href="/marketing-pod"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "marketingPod" ? "text-green-600" : ""
              }`}
            >
              Marketing Pod
            </a>

            {/* <a
              href="/influencer"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "influencer" ? "text-green-600" : ""
              }`}
            >
              Influencer
            </a> */}

            {/* <div className="relative">
              <button
                onClick={toggleSolutions}
                className={`flex items-center gap-1  font-semibold ${
                  showSolutions
                    ? "text-green-600"
                    : "text-gray-600 hover:text-green-600"
                }`}
              >
                Solutions{" "}
              </button>
              {showSolutions && (
                <div
                  className="fixed top-[55px] left-0 right-0 bottom-0 z-50 bg-white overflow-x-auto scrollbar-hide"
                  onClick={() => setShowSolutions(false)}
                >
                  <div onClick={(e) => e.stopPropagation()}>
                    <MegaMenu onClose={() => setShowSolutions(false)} />
                  </div>
                </div>
              )}
            </div> */}

            {/* <div
              className="relative"
              ref={channelsRef}
              onMouseEnter={handleChannelsMouseEnter}
              onMouseLeave={handleChannelsMouseLeave}
            >
              <button
                className={`font-semibold ${
                  showChannels ||
                  currentPage === "fcm" ||
                  currentPage === "onCallFieldForce" ||
                  currentPage === "influencerCampaign"
                    ? "text-green-600"
                    : "text-gray-600 hover:text-green-600"
                }`}
              >
                Solutions
              </button>
              {showChannels && (
                <div
                  className="absolute top-full mt-1 left-0 min-w-[200px] bg-white border border-gray-200 rounded shadow-lg z-50"
                  onMouseEnter={handleChannelsMouseEnter}
                  onMouseLeave={handleChannelsMouseLeave}
                >
                  <div className="py-1">
                    <a
                      href="/fcm"
                      className={`block px-4 py-2 text-sm hover:bg-gray-100 ${
                        currentPage === "fcm"
                          ? "text-green-600 bg-gray-50"
                          : "text-gray-600"
                      }`}
                    >
                      Sales Force Monitor
                    </a>
                    <a
                      href="/oncallfieldforce"
                      className={`block px-4 py-2 text-sm hover:bg-gray-100 ${
                        currentPage === "onCallFieldForce"
                          ? "text-green-600 bg-gray-50"
                          : "text-gray-600"
                      }`}
                    >
                      On-Request Field Force
                    </a>
                    <a
                      href="/influencerCampaign"
                      className={`block px-4 py-2 text-sm hover:bg-gray-100 ${
                        currentPage === "influencerCampaign"
                          ? "text-green-600 bg-gray-50"
                          : "text-gray-600"
                      }`}
                    >
                      Influencer Marketing
                    </a>
                  </div>
                </div>
              )}
            </div> */}
            <a
              href="/pricing"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "price" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Pricing
            </a>
            {/* <a
              href="/careers"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "Careers" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Careers
            </a> */}
             <a
              href="/contact-us"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "contact-us" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Contact Us
            </a>
          </nav>
        </div>
        <div className="hidden md:block ">
          <div className="flex flex-row" ref={partnerRef}>
            {/* <Button
              onClick={togglePartnerMenu}
              variant="outline"
              className="border-none mr-2 transition duration-300 ease-in-out transform hover:scale-105 hover:text-black text-gray rounded-sm px-3 py-2 h-auto flex items-center space-x-2"
            >
              <span>Partner with us</span>
              <ChevronDown size={16} />
            </Button> */}

            {showPartnerMenu && (
              <div
                className="absolute top-full -mt-1 right-34 w-48 bg-white border border-gray-200 rounded shadow-lg z-50"
                onClick={(e) => e.stopPropagation()}
              >
                <ul className="py-1">
                  <li>
                    <a
                      onClick={() => window.open("/partner-us", "_blank")}
                      className="block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                    >
                      Influencer
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => window.open("/freelancefo", "_blank")}
                      className="block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                    >
                      Freelance Field Officer
                    </a>
                  </li>
                </ul>
              </div>
            )}

            {/* <Button
              onClick={() => window.open("/auth/signup", "_blank")}
              className="bg-Orange mr-2 transition duration-300 ease-in-out transform hover:scale-105 hover:bg-Orange text-white rounded-sm px-3 py-1.5 h-auto flex items-center space-x-2 font-bold"
            >
              <span>Try for Free</span>
            </Button> */}
            <Button
              onClick={handleLoginClick}
              variant="outline"
              className="bg-primary hover:bg-secondary text-white rounded-sm transition duration-300 ease-in-out transform hover:scale-105 font-bold"
            >
              Login
            </Button>
          </div>
        </div>
        <button className="md:hidden" onClick={toggleMenu}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {isMenuOpen && (
        <div className="md:hidden bg-[#ebf2f0] py-6 px-6">
          <nav className="flex flex-col space-y-4">
            <a
              href="/"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "Home" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Home
            </a>
            <a
              href="/field-force-monitor"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "fieldForceMonitor"
                  ? "text-green-600"
                  : null
              }`}
            >
              Field Force Monitor
            </a>
            <a
              href="/marketing-pod"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "marketingPod"
                  ? "text-green-600"
                  : null
              }`}
            >
              Marketing Pod
            </a>
            {/* <a
              href="/influencer"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "influencer"
                  ? "text-green-600"
                  : null
              }`}
            >
              Influencer
            </a> */}
            {/* <div className="relative">
              <button
                onClick={() => setShowChannels(!showChannels)}
                className={`${
                  showChannels ||
                  currentPage === "fcm" ||
                  currentPage === "onCallFieldForce" ||
                  currentPage === "influencerCampaign"
                    ? "text-green-600"
                    : "text-gray-600 hover:text-green-600"
                }`}
              >
                Solutions
              </button>
              {showChannels && (
                <div className="mt-2 ml-4 space-y-2">
                  <a
                    href="/fcm"
                    className={`block text-sm ${
                      currentPage === "fcm"
                        ? "text-green-600"
                        : "text-gray-600 hover:text-green-600"
                    }`}
                    onClick={() => setShowChannels(false)}
                  >
                    Sales Force Monitor
                  </a>
                  <a
                    href="/oncallfieldforce"
                    className={`block text-sm ${
                      currentPage === "onCallFieldForce"
                        ? "text-green-600"
                        : "text-gray-600 hover:text-green-600"
                    }`}
                    onClick={() => setShowChannels(false)}
                  >
                    On-Request Field Force
                  </a>
                  <a
                    href="/influencerCampaign"
                    className={`block text-sm ${
                      currentPage === "influencerCampaign"
                        ? "text-green-600"
                        : "text-gray-600 hover:text-green-600"
                    }`}
                    onClick={() => setShowChannels(false)}
                  >
                    Influencer Marketing
                  </a>
                </div>
              )}
            </div> */}

            <a
              href="/pricing"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "price" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Pricing
            </a>
{/*             <a
              href="/careers"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "Careers" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Careers
            </a> */}
             <a
              href="/contact-us"
              className={`text-gray-600 hover:text-green-600 ${
                currentPage === "contact-us" && !showSolutions
                  ? "text-green-600"
                  : null
              }`}
            >
              Contact Us
            </a>
          </nav>
          <div className="mt-4">
            {/* <Button
              onClick={() => window.open("/partner-us", "_blank")}
              variant="outline"
              className="mr-2 transition duration-300 ease-in-out transform hover:scale-105 hover:bg-purple-600 hover:text-white text-gray rounded-sm px-3 py-2 h-auto flex items-center space-x-2"
            >
              <span>Partner with us</span>
            </Button> */}
            {/* <Button
              onClick={() => window.open("/auth/signup", "_blank")}
              className="bg-Orange mb-2 hover:bg-Orange w-full transition duration-300 ease-in-out transform  text-white rounded-sm px-3 py-1.5 h-auto flex items-center space-x-2"
            >
              <span>Try for Free</span>
            </Button> */}
            <Button
              onClick={handleLoginClick}
              variant="outline"
              className="w-full bg-primary  hover:bg-secondary  text-white"
            >
              Login
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
